export const TOPIC_DELIMITER = ':'

export function addSuperTopics(topic: string) {
  const topicParts = topic.split(TOPIC_DELIMITER)
  return topicParts.map((_, index) =>
    topicParts.slice(0, index + 1).join(TOPIC_DELIMITER),
  )
}

export function extractGroupNameFromTopic(topicWithGroupName: string) {
  const [groupName, ...topicParts] = topicWithGroupName.split(TOPIC_DELIMITER)
  return { groupName, topic: topicParts.join(TOPIC_DELIMITER) }
}

export const areTopicsRelated = (topicA: string, topicB: string) =>
  topicA.startsWith(topicB) || topicB.startsWith(topicA)
